import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import styles from '../UOAModal/UOAModalStyles';
import styles2 from '../../../Pages/OptionsBoard/OptionsBoardStyles';
import { calcRR, ITMPROB } from './functions';
import premium from './oi.png';
import mobilepremium from './mobileoi.png';
import {
  barDataFunc,
  barDataOIFunc,
  barOptionsOI,
  barOptionsOITwo,
  chartdataFunc,
  chartOptions,
} from './constant';
import OIModelTable from './components/OIModalTable';
import OIModelHeading from './components/OIModelHeading';
import OIModalLoading from './components/OIModalLoading';
import OIModalBars from './components/OIModalBars';
import { BaseURL } from '../../../constants';
import { connect } from 'react-redux';
import ActionTypes from '../../../actions/types';

class OIMODAL extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderBy: '',
      order: '',
      data: [],
      modalLoader: false,
      tableData: [],
      OiState: [],
    };
  }

  getOIModelData = (ticker, date, strike, puttCall, expiration) => {
    this.setState({ modalLoader: true });
    fetch(
      `${BaseURL}/api/get-oi-data?ticker=${ticker}&date=${date}&strike=${strike}&puttCall=${puttCall}&expiration=${expiration}&range=${7}`
    )
      .then(this.checkStatus)
      .then(this.parseJSON)
      .then(async (response) => {
        if (!response || response.error) {
          this.setState({ modalLoader: false });
          return;
        }
        let newResponse = response;
        if (newResponse.length > 0) {
          if (
            moment(newResponse[newResponse.length - 1].date).isSame(
              newResponse[newResponse.length - 2].date
            )
          ) {
            newResponse.pop();
          }
          const StateMapper = newResponse.map((res) => {
            return {
              OI: res.contracts,
              weeks: res.date,
              vol: res.volume,
              closed: res.close,
            };
          });
          let newTableData = await Promise.all(
            newResponse.map(async (res) => {
              let itemProb = res.itm_prob
                ? res.itm_prob
                : await ITMPROB(res, puttCall, expiration);
              let RR = await calcRR(res, puttCall, itemProb, strike);
              return { ...res, itemProb: itemProb, RR: RR };
            })
          );
          this.setState({ OiState: StateMapper });
          this.setState({ tableData: newTableData, data: response });
          this.setState({ modalLoader: false });
        }
      });
  };

  componentDidMount() {
    const type = this.props.type;
    const ticker = this.props.ticker;
    const date = this.props.selectedDate;
    const strike = this.props.modalRowData.strike;

    let puttCallSplit;
    let puttCallvalue;
    if (type === 'stockPage') {
      puttCallSplit = this.props.modalRowData.option.split('');
      puttCallvalue = puttCallSplit[0];
    }
    const puttCall =
      type === 'stockPage' ? puttCallvalue : this.props.modalRowData.put_call;
    console.log({ puttCall });
    const expiration = this.props.expiration;
    this.props.accessLevel === 'fullaccess' &&
      this.getOIModelData(ticker, date, strike, puttCall, expiration);
  }

  checkStatus = (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    const error = new Error(`HTTP Error: ${response.statusText}`);

    error.status = response.statusText;

    error.response = response;
  };
  parseJSON = (response) => {
    if (response) return response.json();
  };

  render() {
    const { showModal, closeOIModal, accessLevel } = this.props;
    const { isMobile } = this.props.appState;
    const { orderBy, order, OiState } = this.state;
    const Oi = [];
    const close = [];
    const volume = [];
    const weeks = [];
    for (const [, value] of Object.entries(OiState)) {
      let newWeeks = moment(value.weeks).format('DD-MMM');
      weeks.push(newWeeks);

      close.push(value.closed);

      volume.push(value.vol);

      Oi.push(value.OI);
    }

    const labels = weeks;

    const chartdata = chartdataFunc(labels, close);

    const barData = barDataFunc(weeks, volume);
    const barDataOI = barDataOIFunc(weeks, Oi);

    let puttCallSplit;
    let puttCallvalue;
    if (this.props.type === 'stockPage' && this.props.modalRowData.option) {
      puttCallSplit = this.props.modalRowData.option.split('');
      puttCallvalue = puttCallSplit[0];
    }
    console.log({ isMobile })
    return (
      <div style={isMobile ? { width: '220px' } : { width: '400px' }}>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={showModal}
          onClose={closeOIModal}
        >
          <div
            style={
              isMobile
                ? styles.boardModalContentMobile
                : styles.boardModalContent
            }
          >
            <div
              onClick={() => closeOIModal()}
              style={
                !isMobile
                  ? styles.modalCloseButton
                  : styles.modalCloseButtonMobile
              }
            >
              X
            </div>

            <div style={styles.boardModalData}>
              <OIModelHeading
                puttCallvalue={puttCallvalue}
                props={this.props}
              />
              {accessLevel === 'halfaccess' ? (
                <div style={styles.premiumdiv}>
                  <div>
                    <img
                      height="100%"
                      width="100%"
                      src={isMobile ? mobilepremium : premium}
                      alt=""
                    />
                  </div>
                </div>
              ) : this.state.modalLoader ? (
                <OIModalLoading />
              ) : (
                <div>
                  <OIModalBars
                    styles2={styles2}
                    isMobile={isMobile}
                    chartdata={chartdata}
                    chartOptions={chartOptions}
                    barData={barData}
                    barOptionsOI={barOptionsOI}
                    barDataOI={barDataOI}
                    barOptionsOITwo={barOptionsOITwo}
                  />
                  <OIModelTable
                    styles={styles}
                    styles2={styles2}
                    order={order}
                    orderBy={orderBy}
                    state={this.state}
                    setState={(data) => this.setState(data)}
                  />
                </div>
              )}
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}



const mapStateToProps = (state) => ({
  appState: state.appReducer,
});

const mapDispatchToProps = (dispatch) => ({
  setAppStateAction: (newState) =>
    dispatch({
      type: ActionTypes.SET_APP_STATE,
      payload: newState,
    }),
});
export default connect(mapStateToProps, mapDispatchToProps)(OIMODAL);


// WEBPACK FOOTER //
// ./src/components/Modals/OI Modal/index.js